import { useTranslation } from "react-i18next";
import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { apiClient } from "@/lib/api";
import { toast } from "sonner";

/** PayPal redirect flow — cancel_url: buyer abandoned on PayPal.
 * Cancels the pending order (cart is kept) and goes back to the cart. */
export default function PaypalCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    const done = () => {
      toast.info(t("pp.cancelledToast"));
      navigate("/cart", { replace: true });
    };
    if (token) {
      apiClient.post("/payments/paypal/cancel-token", { token }).finally(done);
    } else {
      done();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="paypal-cancel-page">
      <Loader2 className="w-6 h-6 mx-auto animate-spin text-mute mb-3" />
      <h1 className="font-display text-2xl font-semibold">Annulation du paiement…</h1>
    </div>
  );
}
